/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Stock_Adjustment_Not_ReadyInputs */

const en_error_stock_adjustment_not_ready = /** @type {(inputs: Error_Stock_Adjustment_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The adjustment cannot go to Business Central: its account or some lines are not right.`)
};

/**
* | output |
* | --- |
* | "The adjustment cannot go to Business Central: its account or some lines are not right." |
*
* @param {Error_Stock_Adjustment_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_stock_adjustment_not_ready = /** @type {((inputs?: Error_Stock_Adjustment_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Stock_Adjustment_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_stock_adjustment_not_ready(inputs)
});